import { render, staticRenderFns } from "./warehouseManagement.vue?vue&type=template&id=0bffb9cf"
import script from "./warehouseManagement.vue?vue&type=script&lang=js"
export * from "./warehouseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports